"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternationalError = exports.InternationalErrorCodes = void 0;
const errors_1 = require("@deliverr/errors");
var InternationalErrorCodes;
(function (InternationalErrorCodes) {
    InternationalErrorCodes["INVALID_API_KEY"] = "INVALID_API_KEY";
    InternationalErrorCodes["INVALID_BUSINESS_NAME"] = "INVALID_BUSINESS_NAME";
    InternationalErrorCodes["INVALID_REQUEST"] = "INVALID_REQUEST";
    InternationalErrorCodes["UNAUTHORIZED"] = "UNAUTHORIZED";
    InternationalErrorCodes["UNKNOWN"] = "UNKNOWN";
})(InternationalErrorCodes || (exports.InternationalErrorCodes = InternationalErrorCodes = {}));
class InternationalError extends errors_1.AbstractDeliverrError {
    toJSON() {
        return {
            code: this.code,
            message: this.message,
        };
    }
}
exports.InternationalError = InternationalError;
//# sourceMappingURL=InternationalErrors.js.map